

<thm-data-loader path="kilavuz/kilavuz-getir" (errorOccurred)="sayfaYuklenemedi($event)">
    <ng-template let-data>
        <h2 class="thm-page-title ng-star-inserted"> {{ 'kilavuzlar.pageTitle' | transloco }} </h2>
        <br/>

        <thm-alert type="warning" class="w-100" *ngIf="!data.kilavuzVarMi">
            <span [innerHTML]="'kilavuzlar.kilavuzBulunamadi' | transloco"></span>
        </thm-alert>

        <div *ngIf="data.kilavuzVarMi" class="kilavuz-list">
            <div *ngFor="let kilavuz of data.kilavuzlar" class="kilavuz">
                <img src="{{kilavuz.fotoUrl}}" />
            
                <div class="content">
                    <span class="baslik">{{kilavuz.baslik}}</span>
                    <a href="{{kilavuz.dosyaUrl}}" target="_blank" class="download mt-2">
                        <i class="fa fa-external-link" aria-hidden="true"></i>
                        <span style="padding-left: 4px;">{{ 'kilavuzlar.dosyaAc' | transloco }}</span>
                    </a>
                </div>
            
            </div>
        </div>
    </ng-template>
</thm-data-loader>
